module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-area",
    attrs: {
      "id": _vm.titleData.title
    }
  }, [_c('div', {
    staticClass: "area-title"
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "type": _vm.titleData.icon
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.titleData.title))])], 1), _vm._v(" "), _vm._l((_vm.areaData), function(item) {
    return _c('my-card', {
      key: item.id,
      attrs: {
        "cardData": item
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-96769958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/first/component/my-area.vue
// module id = 31
// module chunks = 0